import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { IInstantPayAvailability } from 'src/modules/talent-dashboard/interfaces/instant-pay.interface';

@Component({
  selector: 'app-payment-timer',
  templateUrl: './payment-timer.component.html',
  styleUrls: ['./payment-timer.component.scss'],
})
export class PaymentTimerComponent implements OnInit {

@Input() instantPayAvailability: IInstantPayAvailability;

  timeRemainingSeconds: number = 0;
  progressPercent: number = 0;

  // Instant pay cooldown is always 7 days (604800 seconds)
  private readonly COOLDOWN_SECONDS = 7 * 24 * 60 * 60;

  timeDetails: {
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
  } | null = null;

  private timerSubscription: Subscription;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    if (this.instantPayAvailability && !this.instantPayAvailability.isAvailable) {
      this.timeRemainingSeconds = this.instantPayAvailability.timeRemainingSeconds;
      this.updateFormattedTime();
      this.startTimer();
    }
  }

  startTimer() {
    // Clear existing timer if any
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    // Only start timer if there's time remaining
    if (this.timeRemainingSeconds > 0) {
      this.timerSubscription = interval(1000).subscribe(() => {
        if (this.timeRemainingSeconds > 0) {
          this.timeRemainingSeconds--;
          this.updateFormattedTime();
          this.cdr.detectChanges();
        } else {
          // Timer reached zero — switch to available state
          this.timerSubscription.unsubscribe();
          this.timeDetails = null;
          this.instantPayAvailability = {
            ...this.instantPayAvailability,
            isAvailable: true,
            timeRemainingSeconds: 0
          };
          this.cdr.detectChanges();
        }
      });
    }
  }

  updateFormattedTime() {
    if (this.timeRemainingSeconds <= 0) {
      this.timeDetails = null;
      return;
    }

    const days = Math.floor(this.timeRemainingSeconds / 86400);
    const hours = Math.floor((this.timeRemainingSeconds % 86400) / 3600);
    const minutes = Math.floor((this.timeRemainingSeconds % 3600) / 60);
    const seconds = this.timeRemainingSeconds % 60;

    this.timeDetails = {
      days: days.toString().padStart(2, '0'),
      hours: hours.toString().padStart(2, '0'),
      minutes: minutes.toString().padStart(2, '0'),
      seconds: seconds.toString().padStart(2, '0')
    };

    // Progress = elapsed time out of 7-day cooldown
    const elapsed = this.COOLDOWN_SECONDS - this.timeRemainingSeconds;
    this.progressPercent = Math.min(100, Math.max(0, (elapsed / this.COOLDOWN_SECONDS) * 100));
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}
